import { render, staticRenderFns } from "./FormFoldManagement.vue?vue&type=template&id=872e3c0e&scoped=true&"
import script from "./FormFoldManagement.vue?vue&type=script&lang=js&"
export * from "./FormFoldManagement.vue?vue&type=script&lang=js&"
import style0 from "./FormFoldManagement.vue?vue&type=style&index=0&id=872e3c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872e3c0e",
  null
  
)

export default component.exports